import React, { useState, useEffect, useCallback } from 'react';
import PageComponent from '../../Components/PageComponent';
import Sidebar from '../../Components/Sidebar';
import { getPopupBanner, updatePopupBanner, toggleActiveStatus } from '../../controllers/popupBanner.controller'; // Import toggleActiveStatus

function PopupBanner() {
  const [currentImage, setCurrentImage] = useState(null);
  const [newImage, setNewImage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [imageId, setImageId] = useState(null);
  const [activeStatus, setActiveStatus] = useState(false);  // Add state for active status

  const fetchBanner = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getPopupBanner();
      console.log("response : ", response?.data);
      setCurrentImage(response?.data?.data?.image_url); // Corrected path
      setImageId(response?.data?.data?.id); // Store the image ID
      setActiveStatus(response?.data?.data?.activeStatus === "Active"); // Set initial status
    } catch (error) {
      console.error("Error fetching banner:", error);
      setError("Failed to load current banner image.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchBanner();
  }, [fetchBanner]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setNewImage(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newImage) {
      alert("Please select an image to update.");
      return;
    }

    try {
      setLoading(true);
      await updatePopupBanner(newImage, imageId); // Pass the id to updatePopupBanner
      alert("Popup banner updated successfully!");
      setNewImage(null);
      fetchBanner(); // Refresh the current image
    } catch (error) {
      console.error("Error updating popup banner:", error);
      setError("Failed to update popup banner.");
    } finally {
      setLoading(false);
    }
  };

  const handleToggleStatus = async () => {
    try {
      setLoading(true);
      const newStatus = activeStatus ? "Inactive" : "Active"; // Determine the new status
      const response = await toggleActiveStatus(imageId, newStatus);  // Get the API Response here
      if (response.success) {
        setActiveStatus(response?.data?.activeStatus === "Active"); // Set active status based on the API

        alert("Active status updated successfully!");
      }
      else {
        setError(response.message);
      }
      fetchBanner();

    } catch (error) {
      console.error("Error toggling active status:", error);
      setError("Failed to update active status.");
      //Revert back to the initial state
      setActiveStatus(activeStatus);
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageComponent>
      <div className="flex w-screen h-screen overflow-x-hidden bg-[#F8F7FA]">
        <div className="fixed top-0 left-0 w-64 h-full overflow-y-auto bg-white shadow-md">
          <Sidebar />
        </div>
        <div className="flex-1 p-6 ml-64">
          <div className="flex items-center space-x-2 text-3xl text-gray-500">
            <span>Home Page</span>
            <span>/</span>
            <span className="text-black">Popup Banner</span>
          </div>

          <div className="flex flex-col items-center justify-center h-full mt-6">
            {loading && <p>Loading...</p>}
            {error && <p className="text-red-500">{error}</p>}

            <form onSubmit={handleSubmit} className="w-full max-w-3xl"> {/* Increased max-width */}

              {/* Browse Image and Update Button */}
              <div className="flex items-center w-full">
                <input
                  type="file"
                  id="browse-image"
                  onChange={handleImageChange}
                  accept="image/*"
                  className="flex-grow px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                />
                <button
                  type="submit"
                  className="ml-4 py-2 px-4 text-white bg-[#92288C] rounded-md hover:bg-[#6C0B67] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                  disabled={loading || !newImage}
                >
                  {loading ? "Updating..." : "Update"}
                </button>
              </div>

              {/* Current Image Display and Toggle Button */}
              {currentImage && (
                <div className="flex items-center w-full mt-4"> {/* Adjusted to flex container */}
                  <img
                    src={newImage ? URL.createObjectURL(newImage) : currentImage}
                    alt="Current Popup Banner"
                    className="object-contain rounded-lg shadow-md max-h-80"  //Increased max-h
                  />

                  {/* Toggle Switch */}
                  <label className="inline-flex items-center ml-4 cursor-pointer"> {/* Reduced marginLeft  and remove justify-between from parent and added to it's child so that the parent image do not lose their width */}
                    <input
                      type="checkbox"
                      value=""
                      className="sr-only peer"
                      checked={activeStatus}
                      onChange={handleToggleStatus}
                      disabled={loading}
                    />
                    <div className={`relative w-14 h-7 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-7 peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600 ${loading ? 'cursor-not-allowed opacity-50' : ''}`}></div> {/* Increased size */}
                    <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">{activeStatus ? "Active" : "Inactive"}</span>
                  </label>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </PageComponent>
  );
}

export default PopupBanner;